import React from 'react';
import { mockData } from '../../mock';

const FooterSection = ({ onScrollToSection }) => {
  const { brand, contact } = mockData;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>{brand.name}</h3>
            <p
              lang="sa"
              style={{
                fontSize: '1rem',
                letterSpacing: '0.08em',
                color: 'var(--brand-accent, #FFD700)',
                marginBottom: '0.3rem',
              }}
            >
              {brand.sanskritMotto}
            </p>
            <p
              style={{
                fontSize: '0.8rem',
                letterSpacing: '0.2em',
                textTransform: 'uppercase',
                opacity: 0.7,
                marginBottom: '0.75rem',
              }}
            >
              {brand.mottoTranslation}
            </p>
            <p
              style={{
                fontSize: '0.95rem',
                fontWeight: 600,
                marginBottom: '0.5rem',
                color: 'var(--brand-primary, #1DB954)',
              }}
              data-testid="footer-tagline"
            >
              {brand.tagline}
            </p>
            <p>{brand.description}</p>
          </div>
          <div className="footer-links">
            <div>
              <h4>Explore</h4>
              <ul>
                <li>
                  <a
                    href="/assessment"
                    data-testid="footer-link-assessment"
                  >
                    Assessment
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => onScrollToSection('framework')}
                    data-testid="footer-link-framework"
                  >
                    Framework
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => onScrollToSection('programs')}
                    data-testid="footer-link-programs"
                  >
                    Programs
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => onScrollToSection('audiences')}
                    data-testid="footer-link-audiences"
                  >
                    Who We Help
                  </a>
                </li>
                <li>
                  <a href="/blog" data-testid="footer-link-blog">
                    Blog
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4>Contact</h4>
              <ul>
                <li>{contact.email}</li>
                <li>{contact.phone}</li>
                <li>{contact.address}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {currentYear} {brand.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
